import React, {Component} from 'react'
import { withApollo } from 'react-apollo'
import { Queries, Mutations } from '../../../../graphql'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Tabs, Typography, Spin, Row, Col, Input, message, Table, Icon, Button, Popconfirm, Form, Select, DatePicker} from 'antd'
import Container from '../../../../components/user/Container'
import FromInput from '../../../../components/user/from/Input'
import InputDateStartEnd from '../../../../components/user/from/InputDateStartEnd'
import { checkType } from '../../../../utils/checkType'
import { numberWithCommas } from '../../../../utils/number'
import { changeFormatdate, getTimeFromMins } from '../../../../utils/formatdate'
import { approveStatus } from '../../../../utils/leave'
import { checkMoreThanLess } from '../../../../utils/formatdate'

import moment from 'moment'

const { TabPane } = Tabs
const { Text, Title } = Typography
const { Option } = Select;

const newsDataProfile = '';

class SearchForm extends Component {

	state = {
		loading:true,
		dataTalbe: [],
		columns: [
            {
               // title: 'เลขที่เอกสาร',
               title: 'เลขที่เอกสาร',
               dataIndex: 'docNo',
               width:150,
               // align:'center',
               render: (item, record, index) => <span>{ item }</span>
               // render: (item, record, index) => <span>{ item }</span>
            },
			   // {
            //     title: 'ชื่อ-นามสกุล',
            //     dataIndex: 'employeeName',
            //     width:'200px',
				//    align:'center',
            //     render: (item, record, index) => <span>{ item }</span>
            // },
			   {
                title: 'วันที่เริ่มลา',
                dataIndex: 'leaveStartDate',
                width:'200px',
				   align:'center',
                render: (item, record, index) => <span>{ item ? changeFormatdate(item) : '-' }</span>
            },
			   {
                title: 'วันที่สิ้นสุดการลา',
                dataIndex: 'leaveEndDate',
                align:'center',
                width:'200px',
                render: (item, record, index) => <span>{ item ? changeFormatdate(item) : '-' }</span>
            },
            {
                title: 'ประเภทการลา',
                dataIndex: 'leaveTypeName',
                width:'150px',
				   align:'center',
                render: (item, record, index) => <span>{ item }</span>
            },
			// {
            //     title: 'วันที่เรื่มลา',
            //     dataIndex: 'leaveStartDate',
            //     width:'150px',
            //     render: (item, record, index) => <span>{ item ? changeFormatdate(item) : '-' }</span>
            // },
			{
                title: 'จำนวนวันลา',
                dataIndex: 'leaveDay',
				   align:"center",
                // render: (item, record, index) => <span>{}</span>
                width:'130px',
                render: (item, record, index) => <span>{  record.leaveHour.value ? getTimeFromMins(record.leaveHour.value) : item+' วัน' }</span>
            },
            
			{
                title: 'สถานะ',
				   align:'center',
                dataIndex: 'approveStatus',
                width:'100px',
                render: (item, record, index) => <span>{ item ? approveStatus(item) : item }</span>
            },
            {
                title: 'จัดการ',
                dataIndex: '7',
				   align:'center',
                  width:100,
                fixed: 'right',
                render: (item, record, index) => {
                    return <>
								<Link
									to={{
										pathname: record.docId ? '/Leave/day/edit/'+record.docId : '/Leave/day/darf/'+record.wdLeaveId
									}}
								>
									<Icon type="form" className="mr-2" style={{ color:"#000" }}/>
                           {/* { record.wdLeaveId } */}
								</Link>
								{/* {
									record.status == 'DRAFT' &&
									<Popconfirm placement="topRight" title={"คุณต้องการที่จะลบ"} onConfirm={ () => this.delectField(record.wdHospitalId)} okText="ตกลง" cancelText="ยกเลิก">
										<Icon type="delete"/>
									</Popconfirm>
								} */}
							</>
                }
            },
        ],
		pageData: {
            offset: 0,
            limit: 10
        },
        pagination: {
            total: 10,
        },
        disabledDateStart:moment(new Date).add(-1, 'year'),
		endStartValues:moment(new Date).add(1, 'year'),
		valueStatus:"A",
		preLoadSubmit:true,
		formValue:null,
		dropdownLeaveType:[]
	}

   onChangeNameDivitions = (division, department) =>{
      if(division && department){
         return <p className="mb-0">{ division+' / '+department }</p>;
      }else if(division){
         return <p className="mb-0">{ division }</p>;
      }else if(department){
         return <p className="mb-0">{ department }</p>;
      }else{
         return <p className="mb-0" style={{ textAlign:"center" }}> - </p>
      }
   }

	dropdownLeaveType = async ()=>{
        const { client, location, match } = this.props
        const { empCode } = this.state
        const { data, errors } = await client.query({
            query: Queries.dropdownLeaveType,
            variables:{
                // empCode
                isReqByEmp:true
            }
        })

        console.log('data.dropdownLeaveType',data.dropdownLeaveType)

        if(data.dropdownLeaveType){
            await this.setState({
                dropdownLeaveType: data.dropdownLeaveType,
            })
        }
    }

	fetchLeaveDocumentList = async()=>{
		const { client,location ,match } = this.props
        const { offset ,limit, disabledDateStart, endStartValues } = this.state

        await this.setState({
            preLoadSubmit:true,
			loading:true
        })

        const { data, errors } = await client.query({
            query: Queries.fetchLeaveDocumentList,
			variables:{
				// leaveStartDate:disabledDateStart,
				// leaveEndDate:endStartValues,
				// leaveTypeId:"A",
				approveStatus:"A"
			}
        })


		console.log('datasssss',data)

		if(data.fetchLeaveDocumentList){
			await this.setState({
				dataTalbe: data.fetchLeaveDocumentList,
				loading:false,
				preLoadSubmit:false,
			})
		}else{
			await this.setState({
				loading:false,
				preLoadSubmit:false,
			})
		}
	}

	handleSubmit = async (e) => {
        const { form, afterSubmit, client } = this.props
        const { telNo, otpToken, refCode } = this.state
		await e.preventDefault()
		form.validateFields(async (err, values) => {
			console.log('values',values)
			await this.setState({
				formValue: e
			})

			// await this.fetchLeaveDocumentList(values)
			if (!err) {
                try {
					const { data, errors } = await client.query({
						query: Queries.fetchLeaveDocumentList,
						variables: {
							...values
						}
					})
		
					console.log('fetchLeaveDocumentList',data.fetchLeaveDocumentList)
					
					if(data.fetchLeaveDocumentList){
						await this.setState({
							dataTalbe: data.fetchLeaveDocumentList,
							loading:false,
							preLoadSubmit:false,
						})
					}else{
						await this.setState({
							loading:false,
							preLoadSubmit:false,
						})
					}
                }catch (error) {
					console.log('error',error)
                }
			}
		})
	}
	
	delectField = async(wdHospitalId) =>{
		const { form, client } = this.props
		const { formValue } = this.state
		console.log(formValue)
		try {
			const { data, errors } = await client.mutate({
				mutation: Mutations.destroyWDHospital,
				variables: {
					wdHospitalId
				}
			})
			// console.log(data)
			if(data){
				message.success("ทำการลบรายการขอเบิก")
				if(formValue){
					await this.handleSubmit(formValue)
					// await this.fetchLeaveDocumentList(formValue)
				}else{
					this.fetchLeaveDocumentList()
				}
			}
			
		}catch (error) {
			this.setState({
				preLoadOnsubmit: false
			})
			console.log('error',error)
		}
	}

	clearInput = async () =>{
		await this.setState({
			formValue:null,
			disabledDateStart:moment(new Date).add(-1, 'year'),
			endStartValues:moment(new Date).add(1, 'year')
		})
		this.props.form.resetFields();
	}

	onChangeValueDateStart = async (e) =>{

		const { endStartValues } = this.state

		await this.setState({
			 disabledDateStart: moment(e),
		})
		console.log('endStartValues',endStartValues)

        let checkDatemore = checkMoreThanLess(e, endStartValues)

        if(checkDatemore){
            await this.props.form.setFieldsValue({
            	leaveEndDate: checkDatemore,
            })

			await this.setState({
				endStartValues: checkDatemore
			})
        }
	 }

	onChangeValueDateEnd = async (e) =>{
		await this.setState({
			endStartValues: moment(e),
		})
	}

	onChangeStatus = async (e) =>{
		// this.form.resetFields('endDate')
		// await this.setState({
		// 	 disabledDateStart: moment(e),
		// })
	}
 
	disabledDate = (current) =>{
		 const { disabledDateStart } = this.state
		 return current && current < disabledDateStart;
	}

	async componentDidMount(){
      window.scrollTo(0, 0);
		await this.fetchLeaveDocumentList()
		// await this.dropdownLeaveType()
    }

	render() {
		const { match } = this.props
		const { dataTalbe, columns, loading, pagination, valuesEndDate, disabledDateStart, endStartValues, preLoadSubmit, dropdownLeaveType} = this.state
		const { getFieldDecorator } = this.props.form;
		console.log('sssdataTalbe',dataTalbe)
		return (
			<Container match={match}>
				<div className="breadcrumb-custom pb-3 mb-5">
                    {/* <Breadcrumb.Item> */}
                        <span style={{ fontSize:"18px" }}>การลา / รายการขอลาทั้งหมด </span>
                    {/* </Breadcrumb.Item> */}
                </div>
				<div className="card-container" id="page-profile">
					<div className="px-5 py-1 card-bg-green">
						<Form onSubmit={this.handleSubmit}>
							<Row gutter={16} type="flex" justify="left" align="top" className="box-color-white mb-0" >
								<Col xs={24} md={24} className="pt-2  mb-3">
									<strong className="color-red">
										ค้นหา
									</strong>
								</Col>

								{/* <Col xs={ 24 } md={6}>
									<Form.Item label={"ประเภทการลา"}>
										{ this.props.form.getFieldDecorator("leaveTypeId", {
											initialValue: "A",
											rules:  [{ 
												message: 'กรุณากรอกเลือกประเภทการลา',
											}],
										})(
											<Select 
												style={{ width: "100%" }}
												showSearch
												placeholder=""
												optionFilterProp="children"
											>
												<Option value={"A"}>ทั้งหมด</Option>
												{
													dropdownLeaveType.length !== 0 ? 
														dropdownLeaveType.map((valuseLabel, keysLabel) =>{
															return <Option value={valuseLabel.value}>{ valuseLabel.label }</Option>
														})
													: ''
												}
											</Select>
										)}
									</Form.Item>
								</Col>
								<Col xs={ 24 } md={6}>
									<Form.Item label="วันที่ลา" className="mb-0">
										{ getFieldDecorator('leaveStartDate', {
											initialValue: disabledDateStart,
											rules:  [{ 
												required:false,
												message: 'กรุณากรอกหรือเลือก วันที่ลา',
											}],
										})(
											<DatePicker  
												className="w-100"  
												placeholder="เลือกวันที่" 
												onChange={(e) => this.onChangeValueDateStart(e)}
												allowClear={false}
											/>
										)}
									</Form.Item>
								</Col>
								
								<Col xs={ 24 } md={6}>
									<Form.Item label="วันที่สิ้นสุดการลา" className="mb-0">
										{ getFieldDecorator('leaveEndDate', {
											initialValue: endStartValues,
											rules:  [{ 
												required:false,
												message: 'กรุณากรอกหรือเลือก วันที่สิ้นสุดการลา',
											}],
										})(
											<DatePicker 
												disabledDate={this.disabledDate} 
												disabled={ disabledDateStart ? false : true }
												className="w-100" 
												allowClear={false}
												// defaultValue={ valuesEndDate ? moment(valuesEndDate) : '' } 
												placeholder="เลือกวันที่"
												onChange={(e) => this.onChangeValueDateEnd(e)}
											/>
										)}
									</Form.Item>
								</Col> */}
								
								<Col xs={24} md={12}>
                                    <Form.Item label={"ค้นหา"}>
                                        { getFieldDecorator("searchKeyword", {
                                            initialValue: '',
                                            rules:  [{ 
                                                required:false, 
                                            }],
                                        })(
                                            <Input 
                                                className='block-news' 
                                            />
                                        )}
                                    </Form.Item>
                                </Col>

								<Col xs={ 24 } md={12} >
									<Form.Item label={"สถานะ"}>
										{ getFieldDecorator("approveStatus", {
											initialValue: "A",
											rules:  [{ 
												message: 'กรุณากรอกหรือเลือก สถานะ',
											}],
										})(
											<Select style={{ width: "100%" }} onChange={(e) => this.onChangeStatus(e)}>
												<Option value="A">ทั้งหมด</Option>
												<Option value="D">บันทึกร่าง</Option>
												<Option value="W">รออนุมัติ</Option>
												<Option value="Y">อนุมัติ</Option>
												<Option value="N">ไม่อนุมัติ</Option>
												<Option value="PC">รออนุมัติยกเลิก</Option>
												<Option value="AC">อนุมัติยกเลิก</Option>
												<Option value="RC">ไม่อนุมัติยกเลิก</Option>
												<Option value="C">ยกเลิก</Option>
											</Select>
										)}
									</Form.Item>
								</Col>

								<Col xs={24} md={24} align={"right"}>
									{/* <Button type="primary" className="mx-2 btn-white-red" htmlType="submit" onClick={this.clearInput}>
										ล้างค่า
									</Button> */}
									<Button 
										type="primary" 
										id="btn-onsearch" 
										className="ml-2 color-white" 
										htmlType="submit" 
										disabled={preLoadSubmit}
									>
										ค้นหา
									</Button>
									{
										preLoadSubmit &&
										<Spin size="small" />
									}
								</Col>
							</Row>
						</Form>
					</div>
					<div className="px-5 py-1 card-bg-green">
						<Row gutter={16} type="flex" justify="left" align="top" className="box-color-white" >
							<Col xs={24} md={12} className="pt-2 mb-3">
								<strong className="color-red">
									รายการขอลา
								</strong>
							</Col>
							<Col xs={ 24 } md={24} align={"center"}>
								{
									<Table
										locale={{ emptyText: 'ไม่พบข้อมูลรายการ' }} 
										dataSource={dataTalbe} 
										columns={columns} 
										loading={loading}
										// scroll={{ x: 'max-content' }}
										// pagination={pagination}
										// pagination={{ pageSize: dataTalbe.length }}
										scroll={{ x:"max-content", y: '550px' }}
										pagination={false}
										// onChange={this.paginationChange}
										// rowCount={dataTalbe.length}
									/>
								}
								
							</Col>
						</Row>
					</div>
				</div>
			</Container>
		)
	}
}


SearchForm.defaultProps = {
	autoFocus: false
}

SearchForm.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedSearchForm = Form.create()(SearchForm)

export default withApollo(WrappedSearchForm)